export const MIX_IMPORT_STATUS = {
  UPLOADED: 'UPLOADED',
  WAITING_FOR_PRODUCTS: 'WAITING_FOR_PRODUCTS',
  ANALYZING: 'ANALYZING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const MIX_DELIVERY_STATUS = {
  TO_PREPARE: 'TO_PREPARE',
  IN_PROGRESS: 'IN_PROGRESS',
  PREPARED: 'PREPARED',
};

export const MIX_STOCK_STATUS = {
  AVAILABLE: 'AVAILABLE',
  AVAILABLE_IN_PICKING_AREA: 'AVAILABLE_IN_PICKING_AREA',
  REPLENISHMENT_REQUIRED: 'REPLENISHMENT_REQUIRED',
  STORAGE_LOCATION_CHANGE_REQUIRED: 'STORAGE_LOCATION_CHANGE_REQUIRED',
  STOCK_SHORTAGE: 'STOCK_SHORTAGE',
};

export const MIX_PRODUCT_ISSUE_TYPE = {
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  PALLET_QTY_MISSING: 'PALLET_QTY_MISSING',
  PALLET_QTY_INVALID: 'PALLET_QTY_INVALID',
};

export const MIX_IMPORT_STATUS_LABELS = {
  [MIX_IMPORT_STATUS.UPLOADED]: 'Plik wgrany',
  [MIX_IMPORT_STATUS.WAITING_FOR_PRODUCTS]: 'Oczekuje na produkty',
  [MIX_IMPORT_STATUS.ANALYZING]: 'Analiza w toku',
  [MIX_IMPORT_STATUS.COMPLETED]: 'Analiza zakończona',
  [MIX_IMPORT_STATUS.FAILED]: 'Błąd analizy',
};

export const MIX_PRODUCT_ISSUE_LABELS = {
  [MIX_PRODUCT_ISSUE_TYPE.PRODUCT_NOT_FOUND]: 'Brak produktu',
  [MIX_PRODUCT_ISSUE_TYPE.PALLET_QTY_MISSING]: 'Brak ilości pełnej palety',
  [MIX_PRODUCT_ISSUE_TYPE.PALLET_QTY_INVALID]:
    'Niepoprawna ilość pełnej palety',
};

export const MIX_STOCK_STATUS_LABELS = {
  [MIX_STOCK_STATUS.AVAILABLE]: 'Dostępny',
  [MIX_STOCK_STATUS.AVAILABLE_IN_PICKING_AREA]: 'Dostępny w 0D20',
  [MIX_STOCK_STATUS.REPLENISHMENT_REQUIRED]: 'Wymaga uzupełnienia 0D20',
  [MIX_STOCK_STATUS.STORAGE_LOCATION_CHANGE_REQUIRED]: 'Wymagana zmiana składu',
  [MIX_STOCK_STATUS.STOCK_SHORTAGE]: 'Brak zapasu',
};

export const MIX_DELIVERY_STATUS_LABELS = {
  [MIX_DELIVERY_STATUS.TO_PREPARE]: 'Do przygotowania',
  [MIX_DELIVERY_STATUS.IN_PROGRESS]: 'W trakcie',
  [MIX_DELIVERY_STATUS.PREPARED]: 'Przygotowany',
};

export const MIX_POSITION_TYPE_LABELS = {
  MIX: 'Pozycja miksowa',
  FULL_PALLET: 'Pełne palety',
};

export function getMixPositionType(item) {
  return item?.isMixPosition ? 'MIX' : 'FULL_PALLET';
}
